import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from '../images/logo4.png'
import { BiArrowBack } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { clearOtpError, clearUserEmail } from "../redux/otp/otp.reducer";
import { verifyOtp, resendOtp } from "../redux/otp/otp.action";
import toast from "react-hot-toast";

function OtpInput() {
  const initialTimerCount = parseInt(localStorage.getItem("timerCount"));
  const [timerCount, setTimer] = useState(
    initialTimerCount > 0 ? initialTimerCount : 60
  );
  const [OTPinput, setOTPinput] = useState([]);
  const [disable, setDisable] = useState(true);
  const [timerStarted, setTimerStarted] = useState(false); // Flag to track if the timer has started
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const otpinfo = useSelector((state) => state.otp);

  useEffect(() => {
    // Check if the timer has started previously
    const hasTimerStartedPreviously = localStorage.getItem("timerStarted");

    if (hasTimerStartedPreviously) {
      // If the timer has started previously, disable the timer and show resend OTP link
      setTimerStarted(true);
      setDisable(false);
    }

    // Start the timer when the component mounts if it hasn't started previously
    if (!hasTimerStartedPreviously) {
      startTimer();
    }
  }, []);

  const startTimer = () => {
    const interval = setInterval(() => {
      setTimer((lastTimerCount) => {
        if (lastTimerCount <= 1) {
          clearInterval(interval);
          setDisable(false);
          setTimerStarted(true);

          // Store the flag in local storage indicating that the timer has started
          localStorage.setItem("timerStarted", "true");
        }
        return Math.max(0, lastTimerCount - 1);
      });
    }, 1000);
  };

  useEffect(() => {
    localStorage.setItem("timerCount", timerCount.toString());
  }, [timerCount]);

  useEffect(() => {
    if (otpinfo && otpinfo.otpinfo) {
      toast.success("Email Verified Successfully");
      navigate("/resetpass");
      dispatch(clearOtpError())
      localStorage.setItem('verifiedmail',otpinfo.userEmail)
    } else if (otpinfo.otperror) {
      toast.error(otpinfo.otperror);
      dispatch(clearOtpError());
    }
  }, [otpinfo, navigate, dispatch]);

  function OTPverify(e) {
    e.preventDefault();
    if (timerCount > 0) {
      const otp = parseInt(OTPinput.join(''));
      dispatch(verifyOtp({ otp, email: otpinfo.userEmail }));
      setOTPinput(['','','',''])
    } else {
      toast.error("Invalid OTP. Please resend again");
      setOTPinput(['','','',''])
    }
  }
  console.log(OTPinput)
  useEffect(() => {
    return () => {
      dispatch(clearUserEmail());
      localStorage.setItem("timerCount", "0");
      localStorage.removeItem("timerStarted"); // Remove the flag when the component unmounts
    };
  }, []);

  function handleResendOtp() {
    if (!disable) {
      toast.success("Otp Send Succcessfully");
      dispatch(resendOtp({ email: otpinfo.userEmail }))
        .then(() => {
          
          // Reset timer to initial value after OTP is successfully sent
          setTimer(60);
          setDisable(true);
          startTimer(); // Start the timer again when resend OTP is clicked
        })
        .catch((error) => {
          // Handle error if OTP resend fails
          toast.error(error);
          console.error("Error resending OTP:", error);
        });
    }
  }

  return (
    <>
      <div className='py-2 sm:px-8 px-2 shadow flex justify-between items-center'>
        <Link to="/" className='flex items-center'>
          <img src={logo} className='h-16 object-contain' alt="" />
        </Link>
        {otpinfo.isUser ? 
          <Link to="/signin" className='flex items-center gap-2'>
            <BiArrowBack />
            <span>Back to login</span>
          </Link>
        :
          <Link to="/loginProvider" className='flex items-center gap-2'>
            <BiArrowBack />
            <span>Back to login</span>
          </Link>
        }
      </div>

      <div className="flex justify-center items-center w-screen h-screen bg-gray-50">
        <div className="bg-white px-6 pt-10 pb-9 mx-auto w-full max-w-lg rounded-2xl">
          <div className="mx-auto flex w-full max-w-md flex-col space-y-16">
            <div className="flex flex-col items-center justify-center text-center space-y-2">
              <div className="font-semibold text-3xl">
                <p>Email Verification</p>
              </div>
              <div className="flex flex-row text-sm font-medium text-gray-400">
                <p>We have sent a code to your email {otpinfo.userEmail}</p>
              </div>
            </div>

            <div>
              <form onSubmit={OTPverify}>
                <div className="flex flex-col space-y-16">
                  <div className="flex flex-row items-center justify-between mx-auto w-full max-w-xs">
                    {[0, 1, 2, 3].map((index) => (
                      <div key={index} className="w-14 h-14">
                        <input
                          maxLength="1"
                          className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                          type="text"
                          required
                          value={OTPinput[index]}
                          onChange={(e) =>
                            setOTPinput((prevInput) => {
                              const newInput = [...prevInput];
                              newInput[index] = e.target.value;
                              return newInput;
                            })
                          }
                        />
                      </div>
                    ))}
                  </div>

                  <div className="flex flex-col space-y-5">
                    <div>
                      <input
                        type="submit"
                        value={`${otpinfo.otpfetching ? 'Verifying...' : 'Verify otp'}`}
                        className={`flex flex-row cursor-pointer items-center justify-center text-center w-full border rounded-3xl outline-none py-3 bg-orange-500 border-none text-white text-sm shadow-sm ${otpinfo.otpfetching ? 'opacity-70 cursor-not-allowed' : ''} `}
                      />
                    </div>

                    <div className="flex flex-row items-center justify-center text-center text-sm font-medium space-x-1 text-gray-500">
                      <p>Didn't receive code?</p>{" "}
                      <Link
                        className="flex flex-row items-center"
                        onClick={handleResendOtp}
                        style={{
                          color: disable ? "gray" : "blue",
                          cursor: disable ? "none" : "pointer",
                          textDecorationLine: disable ? "none" : "underline",
                        }}
                      >
                        {disable ? `Resend OTP in ${timerCount}s` : "Resend OTP"}
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OtpInput;
